import { render, staticRenderFns } from "./XomeSettings.vue?vue&type=template&id=5d51ad00&"
import script from "./XomeSettings.vue?vue&type=script&lang=js&"
export * from "./XomeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports